import { Box, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import FavoriteIcon from '@mui/icons-material/Favorite';
import BalanceIcon from '@mui/icons-material/Balance';

const features = [
  { title: 'Innovate with AI', desc: 'Solve real-world challenges through cutting-edge technology.', icon: <LightbulbIcon sx={{ color: '#64ffda', fontSize: { xs: 40, sm: 48, md: 56 } }} /> },
  { title: 'Startup Growth', desc: 'Make a meaningful impact in a nimble environment.', icon: <TrendingUpIcon sx={{ color: '#64ffda', fontSize: { xs: 40, sm: 48, md: 56 } }} /> },
  { title: 'Career Development', desc: 'Enhance skills through mentorship and hands-on learning.', icon: <SchoolIcon sx={{ color: '#64ffda', fontSize: { xs: 40, sm: 48, md: 56 } }} /> },
  { title: 'Inclusive Culture', desc: 'Join a collaborative, diverse team.', icon: <PeopleIcon sx={{ color: '#64ffda', fontSize: { xs: 40, sm: 48, md: 56 } }} /> },
  { title: 'Meaningful Work', desc: 'Contribute to socially impactful projects.', icon: <FavoriteIcon sx={{ color: '#64ffda', fontSize: { xs: 40, sm: 48, md: 56 } }} /> },
  { title: 'Work-Life Balance', desc: 'Enjoy flexibility and growth support.', icon: <BalanceIcon sx={{ color: '#64ffda', fontSize: { xs: 40, sm: 48, md: 56 } }} /> },
];

export default function CareersFeatures() {
  return (
    <Box sx={{ py: { xs: 6, sm: 8, md: 12 }, textAlign: 'center', bgcolor: '#000000' }}>
      <Typography variant="h2" sx={{ fontWeight: 700, mb: { xs: 6, sm: 8 } }}>
        Life at Our Company
      </Typography>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={16}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        breakpoints={{
          0: { slidesPerView: 1 },
          480: { slidesPerView: 1.2 },
          600: { slidesPerView: 2 },
          900: { slidesPerView: 2.5 },
          960: { slidesPerView: 3 },
        }}
        style={{ paddingBottom: '50px' }}
      >
        {features.map((item, i) => (
          <SwiperSlide key={i}>
            <Box
              sx={{
                p: { xs: 3, sm: 4 },
                minHeight: { xs: 220, sm: 260 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(20, 20, 20, 0.85)',
                borderRadius: 3,
                textAlign: 'center',
                boxShadow: '0 6px 24px rgba(0,0,0,0.5)',
                backdropFilter: 'blur(6px)',
                transition: 'all 0.3s ease-in-out',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.7)',
                },
              }}
            >
              <Box sx={{ mb: 2 }}>{item.icon}</Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  mb: 1,
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                  color: '#fff',
                }}
              >
                {item.title}
              </Typography>
              <Typography sx={{ color: '#bbb', fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' } }}>
                {item.desc}
              </Typography>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* ===== CUSTOM PAGINATION DOT STYLING ===== */}
      <Box
        sx={{
          '.swiper-pagination-bullet': {
            bgcolor: '#64ffda !important', // active and inactive color
            opacity: 0.7,
            width: { xs: 8, sm: 10 },
            height: { xs: 8, sm: 10 },
          },
          '.swiper-pagination-bullet-active': {
            opacity: 1,
            bgcolor: '#64ffda !important',
          },
        }}
      />
    </Box>
  );
}
